angular.module('app.controllers').controller('ContactCtrl', ['$scope', '$rootScope', 'UI', 'APIForm'].append(function(self, root, UI, APIForm) {
  self.contactModalEl = document.getElementById('contactModal');
  if (self.contactModalEl) {
    self.contactModal = bootstrap.Modal.getOrCreateInstance(self.contactModalEl);
    self.contactModalEl.addEventListener('hidden.bs.modal', function(event) {
      self.$emit('hideContactModal');
      return self.$applyAsync();
    });
    self.contactModalEl.addEventListener('shown.bs.modal', function(event) {
      return self.$applyAsync();
    });
  }
  self.formSuccess = false;
  self.exhibitor_id = null;
  self.resetData = function(email = '') {
    self.data = {
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
      e_email: email,
      call_type: 'Vormittag',
      call_extend: '',
      iam: 'Schüler/in',
      subject: 'Ich möchte nähere Informationen zu einem Lehrberuf/schulischen Ausbildungsschwerpunkt',
      goodie: false,
      message: '',
      address: ''
    };
    return self.formProccess = false;
  };
  self.$on('openContactModal', function(event, email = null, exhibitor_id = null) {
    if (email == null) {
      return;
    }
    self.exhibitor_id = exhibitor_id;
    self.resetData(email);
    self.contactModal.show();
    return self.$applyAsync();
  });
  self.$on('hideContactModal', function(event) {
    self.formSuccess = false;
    self.exhibitor_id = null;
    self.cForm.$setPristine();
    self.cForm.$setUntouched();
    self.resetData();
    return self.$applyAsync();
  });
  self.saveForm = function(form) {
    return self.cForm = form;
  };
  return self.sendContact = function() {
    self.formProccess = true;
    return (new APIForm(self.data)).$save({}, function(data) {
      if (data.success) {
        self.customStat(self.exhibitor_id, 'contact_send');
        self.resetData();
        self.formSuccess = data.success;
      }
      self.cForm.$setPristine();
      return self.cForm.$setUntouched();
    }, function(response) {
      self.formProccess = false;
      return UI.notify(false, response.data.error);
    });
  };
}));
